import type { AppStoreHook, FeatureKey } from "@/store";
import { logClientEvent } from "@/telemetry";

let _appStore: AppStoreHook | undefined;

export const configureFeatureAdoptionStore = (appStore: AppStoreHook): void => {
  _appStore = appStore;
};

const appStore = (): AppStoreHook => {
  if (!_appStore) throw new Error("Feature adoption store is not configured");
  return _appStore;
};

export const recordFeatureUsed = (
  feature: Exclude<FeatureKey, "transcribe">,
): void => {
  const state = appStore().getState();
  const wasAlreadyUsed = Boolean(state.featureFirstUsedAt?.[feature]);
  state.recordFeatureFirstUsed(feature);
  if (!wasAlreadyUsed) logClientEvent("feature.adopted", { feature });
};

export const recordTranscriptCreated = (): void => {
  const state = appStore().getState();
  const wasAlreadyUsed = Boolean(state.featureFirstUsedAt?.transcribe);
  state.recordTranscriptCreated();
  if (!wasAlreadyUsed) {
    logClientEvent("feature.adopted", { feature: "transcribe" });
  }
};
